module.exports = __webpack_public_path__ + "img/bank2.21730bda.png";